import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomTitleSubTitleComponent = styled('div')(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: theme.space._400,
    alignSelf: "stretch",
}));

export const CustomTitle = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.50"],
    fontFamily: theme.fonts.default,
    fontStyle: "normal",
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.shortest,
    alignSelf: "stretch"
}));

export const CustomSubTitle = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.500"],
    fontFamily: theme.fonts.default,
    fontStyle: "normal",
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.tall,
    alignSelf: "stretch"
}));

